var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoactionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2235",
    "data-name": "Rectangle 2235",
    width: 28,
    height: 34,
    transform: "translate(-0.101 0.374)",
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10422",
    "data-name": "Group 10422",
    transform: "translate(1.8 1.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10210",
    "data-name": "Group 10210",
    transform: "translate(-1.7 -2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27575",
    "data-name": "Path 27575",
    d: "M12.421,0A12.426,12.426,0,0,0,0,12.421c0,8.387,10.949,17.856,11.411,18.26a1.561,1.561,0,0,0,2.021,0c.542-.4,11.411-9.873,11.411-18.26A12.426,12.426,0,0,0,12.421,0m0,27.406c-3.308-3.105-9.316-9.8-9.316-14.984a9.316,9.316,0,1,1,18.632,0c0,5.184-6.008,11.9-9.316,14.984m0-21.2a6.211,6.211,0,1,0,6.211,6.211,6.213,6.213,0,0,0-6.211-6.211m0,9.316a3.105,3.105,0,1,1,3.105-3.105,3.106,3.106,0,0,1-3.105,3.105",
    transform: "translate(1.387 1.737)",
    fill: "#101b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoactionIcon);
export default __webpack_public_path__ + "static/media/loaction_icon.065e97928d934c0868cf1b855116d016.svg";
export { ForwardRef as ReactComponent };